export const iconFontAwesomeMedicalHealthHouseMedicalCircleExclamation = (
	<i className="fa-solid fa-house-medical-circle-exclamation"></i>
);
